import { render, staticRenderFns } from "./SH030ShopperTdkInfo.vue?vue&type=template&id=4309cb38&"
import script from "./SH030ShopperTdkInfo.vue?vue&type=script&lang=js&"
export * from "./SH030ShopperTdkInfo.vue?vue&type=script&lang=js&"
import style0 from "./SH030ShopperTdkInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports